<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>Reference</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont" class="comCon">
      <div id="comp">
        <article class="about inner_box">
          <h3 class="comp_tit">주요고객사</h3>
          <v-img src="@/assets/img/common/ci_2031-1.png" alt="" />
          <br />
          <v-img src="@/assets/img/common/ci_2031-2.png" alt="" />
          <br /><br />
          <!-- <v-img src="@/assets/img/dicentral/DiCentralReference3.png" alt="" /> -->
        </article>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
